import React, { useEffect, useState } from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import FormCategoriaPlatillo from "../../../components/menu/categoria/FormCategoriaPlatillo";
import Loader from "../../../components/Loader";
import { useParams, useNavigate } from 'react-router-dom';
import { formSchema } from "../../../validaciones/validacionCategoriaPlatillo";
import convertImageToBase64 from '../../../utils/converitr-imagen-base64';
const DetalleCategoriasPlatillo = () => {
  const [multiImagenes, handleChangeImagen] = useState([])
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
  const [estatus] = useState([{value:1,label:"Activo"},{value:2,label:"Oculto"}]);
  const navigate = useNavigate();
  const { id } = useParams();

  const [datos, setDatos] = useState({
    id,
    nombre:"",
    descripcion:"",
    estatus:1
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos({ ...datos, [name]: value });
  };

  useEffect(() => {

    function obtenerCategoria() {
      // eslint-disable-next-line
      if(id != 0){
        fetch("/p_categoria_platillo",{
          method: "PATCH",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify({id})
        })
        .then((res) => res.json())
        .then(async (data) => {
          console.log(data);
          if(data.status === 1){
            setDatos((x)=>({
              ...x,
              id,
              nombre:data.data[0].NOMBRE_CP || "",
              descripcion:data.data[0].DESCRIPCION_CP || "",
              estatus:data.data[0].ESTATUS_CP || 1
            }));

            if(data.data[0].IMAGEN_CP){
              let imagenesCategorias = []
              let laImagen = `/categorias_platillos/${id}/${data.data[0].IMAGEN_CP}`;
              let base64 = await convertImageToBase64(laImagen);
              imagenesCategorias.push({
                  id,
                  nombre:data.data[0].NOMBRE_CP,
                  file:null,
                  esNuevo:false,
                  preview:base64,
              })
              handleChangeImagen(imagenesCategorias);
            }
  
              
            

            setIsLoading(false);
          } 
        });
      }
      else{
        setIsLoading(false);
      }
    }

    obtenerCategoria()
  }, [id]);

  const handleSave = () => {
    const result = formSchema.safeParse({...datos/* ,multiImagenes:multiImagenes */});
    console.log(result);
    if (!result.success) {
      console.log(result.error.errors);
      console.log(result.error.flatten().fieldErrors);
      setError(result.error.flatten().fieldErrors)
      return;
    }
    else{
      setError(null)
    }

    let datosImagenes = ""
    let formData = new FormData();
    for(let i = 0; i < multiImagenes.length; i++){
        if(multiImagenes[i].esNuevo){
            formData.append('miArchivo', multiImagenes[i].file);
            datosImagenes = multiImagenes[i].nombre
        }
    }
    formData.append('datosImagenes', datosImagenes);
    formData.append('datos', JSON.stringify(datos));
    // eslint-disable-next-line
    if (id == 0) {
      // Create new sucursal
      try {
        fetch("/p_categoria_platillo",{
          method: "POST",
          body: formData
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status === 1){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
    else {
      // Update sucursal
      try {
        fetch("/p_categoria_platillo",{
          method: "PUT",
          body: formData
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status === 1){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  return (
    <>
      <MasterLayout>
        { isLoading ? 
          <Loader /> : 
          <FormCategoriaPlatillo 
            datos={datos} 
            handleChange={handleChange} 
            handleSave={handleSave}
            handleChangeImagen={handleChangeImagen}
            multiImagenes={multiImagenes}
            estatus={estatus}
            error={error}
          />
        }
      </MasterLayout>
    </>
  );
};

export default DetalleCategoriasPlatillo;
